export const ONBOARDING_SESSION_CREATED_EVENT =
  'sandbox:onboarding:session-created';

export const ONBOARDING_SHORTCUT_CREATED_EVENT =
  'sandbox:onboarding:shortcut-created';

export const ONBOARDING_PAYMENT_REFUNDED_EVENT =
  'sandbox:onboarding:payment-refunded';

export const ONBOARDING_STEP_CHANGED_EVENT = 'sandbox:onboarding:step-changed';

export const ONBOARDING_INSERT_SHORTCUT_PATH_EVENT =
  'sandbox:onboarding:insert-shortcut-path';

export interface OnboardingSessionCreatedDetail {
  hostId: number;
  paymentId?: number;
}

export interface OnboardingShortcutCreatedDetail {
  shortcutId: number;
}

export interface OnboardingPaymentRefundedDetail {
  paymentId: number;
}

export interface OnboardingStepChangedDetail {
  action?: string;
  highlightMenu: boolean;
  stepId: string;
}
